import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "dl_cookie_consent";

function readConsent() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

// Baner zgody na cookies: analityka ładuje się dopiero po akceptacji (window.dlLoadAnalytics z index.html)
export function CookieBanner() {
  const [consent, setConsent] = useState(readConsent);
  const [forceOpen, setForceOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const open = () => setForceOpen(true);
    window.addEventListener("open-cookie-settings", open);
    return () => window.removeEventListener("open-cookie-settings", open);
  }, []);

  if (pathname.startsWith("/admin") || (consent && !forceOpen)) return null;

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* localStorage niedostępny */ }
    setConsent(value);
    setForceOpen(false);
    if (value === "all") window.dlLoadAnalytics?.();
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4" role="dialog" aria-label="Zgoda na pliki cookies" data-testid="cookie-banner">
      <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-cyan-400/30 bg-slate-950 p-4 shadow-2xl shadow-black/60 sm:flex-row sm:items-center sm:p-5">
        <Cookie className="hidden h-8 w-8 shrink-0 text-cyan-300 sm:block" />
        <p className="flex-1 text-xs leading-relaxed text-slate-300 sm:text-sm">
          Używamy niezbędnych plików cookies (koszyk, logowanie) oraz — za Twoją zgodą — cookies analitycznych, które pomagają nam ulepszać sklep.
          Szczegóły w <Link to="/polityka-prywatnosci" className="font-semibold text-cyan-300 underline">Polityce prywatności</Link>.
        </p>
        <div className="flex shrink-0 gap-2">
          <button onClick={() => choose("necessary")} data-testid="cookie-necessary" className="rounded-xl border border-slate-600 px-4 py-2.5 text-xs font-bold text-slate-200 transition-colors hover:border-slate-400 sm:text-sm">Tylko niezbędne</button>
          <button onClick={() => choose("all")} data-testid="cookie-accept" className="rounded-xl bg-gradient-to-r from-cyan-500 to-teal-500 px-4 py-2.5 text-xs font-bold text-slate-950 sm:text-sm">Akceptuję wszystkie</button>
        </div>
      </div>
    </div>
  );
}
